module.exports = __webpack_public_path__ + "img/safety_and_comfort.fab9ae2f.jpg";